import { routes as allRoutes } from '@/router';

export const actions = {
  updateRoutes({ commit, state }, userRoles) {
    if (Object.keys(userRoles).length === 0) return;

    const menuItems = allRoutes.filter((route) => route.meta?.menu);
    const modules = new Set(menuItems.map((item) => item.meta.module).filter((module) => module));
    const menuMap = Array.from(modules).map((module) => {
      return {
        label: module || '',
        backgroundImage: state.backgroundImage[module] || '',
        children: menuItems
          .filter((route) => route.meta?.module === module && !route.meta?.dashboard)
          .map((route) => ({
            ...route,
            disabled:
              route.meta.disabled ?? route.meta.permission
                ? userRoles[route.meta.role]?.includes(route.meta.permission) === false
                : false,
          })),
        dashboards: menuItems
          .filter((route) => route.meta?.module === module && route.meta?.dashboard)
          .map((route) => ({
            ...route,
            disabled:
              route.meta.disabled ?? route.meta.permission
                ? userRoles[route.meta.role]?.includes(route.meta.permission) === false
                : false,
          })),
      };
    });

    commit('SET_ROUTES', menuMap);
  },
};
